import "./Partner.module.css";
import HeaderPrincipale from "@/reusable_sections/Header";
import IlNostroNetwork from "./sections/IlNostroNetwork";
import Footer from "../Home/sections/Footer";
export default function PartnerPage() {
  return <div>
      <HeaderPrincipale />
      <IlNostroNetwork />
      <Footer />
    </div>;
}